<div class="form-horizontal">
    <div class="form-group" *ngIf="model.codigo !== ''">
      <label class="col-md-1 control-label">Código:</label>
      <div class="col-md-1">
        <mat-form-field appearance="outline">
          <mat-label>Código Solicitud:</mat-label>
          <input
            matInput
            type="text"
            disabled="disabled"
            aria-label="Contratista"
            name="codigo"
            [value]="model.codigo"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-1 control-label">Compañía:</label>
      <div class="col-md-4">
        <mat-form-field appearance="outline">
          <mat-label> Seleccione: </mat-label>
          <mat-select matSelect [(ngModel)]="model.idCompaniaSelected"
          name="idCompaniaSelected"
          [disabled]="disabled"
          #idCompaniaSelected="ngModel"
          (selectionChange)="companiaChanged()" 
          required>
            <mat-option *ngFor="let company of listaCompanias" [value]="company.idCompania">
              {{ company.nombre }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <label class="col-md-1 control-label">Sede (*):</label>
      <div class="col-md-2">
        <mat-form-field appearance="outline" hideRequiredMarker>
          <mat-label> Seleccione </mat-label>
          <mat-select
            matSelect
            [(ngModel)]="model.idSedeSelected"
            name="idSedeSelected"
            [disabled]="disabled"
            #idSedeSelected="ngModel"
            (selectionChange)="sedeChanged($event)" 
            required
          >
          <!-- <mat-option [value]="0">Seleccione</mat-option> -->
            <mat-option
              *ngFor="let item of listaSedes; index as i"
              [value]="item.idSede"
              >{{ item.nombre }}</mat-option>
          </mat-select>
          <!-- <mat-error *ngIf="idSede.invalid">Requerido</mat-error> -->
        </mat-form-field>
      </div>

    </div>
    <div class="form-group">
      <label class="col-md-1 control-label">Empresa (*):</label>
      <div class="col-md-4">
        <mat-form-field appearance="outline" hideRequiredMarker>
          <mat-label>Empresa</mat-label>
           <mat-select [formControl]="bankServerSideCtrl" *ngIf="!escontratista" placeholder="Empresa" [(ngModel)]="model.idContratista" required>
            <!-- place ngx-mat-select-search inside mat-option to allow opening without initial selection -->
            <mat-option>
              <ngx-mat-select-search [formControl]="bankServerSideFilteringCtrl" [searching]="searching" 
                placeholderLabel="Empresa" 
                noEntriesFoundLabel="No se encontraron coincidencias"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let bank of filteredServerSideBanks | async" [value]="bank.idContratista">
              {{bank.nombre}}
            </mat-option>
          </mat-select>
          <input
            matInput
            *ngIf="escontratista"
            type="text"
            name="contratista"
            [(ngModel)]="model.contratista"
            disabled
          />
        </mat-form-field>
        <!-- Selected Bank: {{model.idContratista}} -->
        <!-- Selected Bank: {{bankServerSideCtrl.value?.idContratista}} -->
      </div>
      <label class="col-md-1 control-label">Fecha Inicio (*):</label>
      <div class="col-md-2">
        <!-- <mat-form-field appearance="outline">
                <input matInput type="date" [(ngModel)]="itemSolicitud.fechaInicio" placeholder="dd/MM/yyyy" name="fechaInicio"/>
              </mat-form-field>    -->
        <mat-form-field appearance="outline" hideRequiredMarker>
          <mat-label>Fecha Inicio</mat-label>
          <input
            matInput
            [matDatepicker]="pckrFechaInicio"
            [(ngModel)]="model.fechaInicio"
            [disabled]="disabled"
            id="fechaInicio"
            name="fechaInicio"
            [max]='model.fechaFin'
            #fechaInicio="ngModel"
            required
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="pckrFechaInicio"
          ></mat-datepicker-toggle>
          <mat-datepicker #pckrFechaInicio></mat-datepicker>
          <!-- <mat-error *ngIf="fechaInicio.invalid">Requerido</mat-error> -->
        </mat-form-field>
      </div>
      <label class="col-md-1 control-label">Fecha Fin (*):</label>
      <div class="col-md-2">
        <!-- <mat-form-field appearance="outline">
                <input matInput type="date" [(ngModel)]="itemSolicitud.fechaFin" placeholder="dd/MM/yyyy" name="fechaFin"/>
              </mat-form-field>    -->
        <mat-form-field appearance="outline" hideRequiredMarker>
          <mat-label>Fecha Fin</mat-label>
          <input
            matInput
            [matDatepicker]="pckrFechaFin"
            [(ngModel)]="model.fechaFin"
            [disabled]="disabled"
            name="fechaFin"
            [min]='model.fechaInicio'
            #fechaFin="ngModel"
            required
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="pckrFechaFin"
          ></mat-datepicker-toggle>
          <mat-datepicker #pckrFechaFin></mat-datepicker>
          <!-- <mat-error *ngIf="fechaFin.invalid">Requerido</mat-error> -->
        </mat-form-field>
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-1 control-label">OC:</label>
      <div class="col-md-2">
        <mat-form-field appearance="outline">
          <mat-label>Orden de compra</mat-label>
          <input
            matInput
            type="text"
            [(ngModel)]="model.ordenCompra"
            id="ordenCompra"
            name="ordenCompra"
            [disabled]="disabled"
            #ordenCompra="ngModel"
            maxlength="20"
          />          
          <!-- <mat-error *ngIf="ordenCompra.invalid">Requerido</mat-error> -->
        </mat-form-field>
        
      </div>
      <label class="col-md-1 col-md-offset-2 control-label">Notificar a:</label>
      <div class="col-md-3">
        <mat-form-field appearance="outline">
          <mat-label>Notificar a</mat-label>
          <input
            matInput
            type="email"
            [(ngModel)]="model.notificarA"
            name="notificarA"
            [disabled]="disabled"
            maxlength="160"
            email #notificarA="ngModel"
          />
          <!-- <mat-error *ngIf="notificarA.invalid">Correo invalido</mat-error> -->
        </mat-form-field>
        
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-1 control-label">Trabajo (*):</label>
      <div class="col-md-4">
        <mat-form-field appearance="outline" hideRequiredMarker>
          <mat-label>Trabajo</mat-label>
          <input
            matInput
            type="text"
            [(ngModel)]="model.trabajo"
            id="trabajo"
            name="trabajo"
            [disabled]="disabled"
            #trabajo="ngModel"
            maxlength="120"
            required
          />
          <!-- <mat-error *ngIf="trabajo.invalid">Requerido</mat-error> -->
        </mat-form-field>
      </div>
      <label class="col-md-1 control-label">Subcontratista:</label>
      <div class="col-md-5">
        <mat-form-field appearance="outline">
          <mat-label>Subcontratista</mat-label>
          <input
            matInput
            type="text"
            [(ngModel)]="model.subContratista"
            id="subContratista"
            name="subContratista"
            [disabled]="disabled"
            #subContratista="ngModel"
            maxlength="100"
          />
          <!-- <mat-error *ngIf="notificarA.invalid">Correo invalido</mat-error> -->
        </mat-form-field>
        
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-1 control-label">Motivo (*):</label>
      <div class="col-md-10">
        <mat-form-field class="example-full-width" appearance="outline" hideRequiredMarker>
          <mat-label>Motivo</mat-label>
          <textarea
            matInput
            placeholder="Motivo"
            [(ngModel)]="model.motivo"
            rows="5"
            id="motivo"
            name="motivo"
            [disabled]="disabled"
            #motivo="ngModel" [maxlength]="2000"
            required
          ></textarea>          
          <!-- <mat-error *ngIf="motivo.invalid">Requerido</mat-error> -->
        </mat-form-field>
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-1 control-label">Tipo de visita (*):</label>
      <div class="col-md-2">
        <mat-form-field appearance="outline" hideRequiredMarker>
          <mat-label>Seleccione</mat-label>
          <mat-select
            matSelect
            *ngIf="!escontratista" 
            [(ngModel)]="model.idTipoVisitaSelected"
            name="idTipoVisitaSelected"
            [disabled]="disabled"
            idTipoVisitaSelected="ngModel"
            (selectionChange)="tipoVisitaChanged($event)"
            required
          >
          <!-- <mat-option [value]="0">Seleccione</mat-option> -->
            <mat-option
              *ngFor="let item of listaTipoVisita; index as i"
              [value]="item.idTipoVisita"
              >{{ item.nombre }}</mat-option
            >
          </mat-select>
          <input
            matInput
            *ngIf="escontratista"
            id="tipoVisita"
            name="tipoVisita"
            type="text"
            [(ngModel)]="model.tipoVisita"
            disabled
          />
        </mat-form-field>
      </div>
      <label class="col-md-1 control-label" *ngIf="escontratista" >Responsable Engie (*):</label>
      <div class="col-md-2" *ngIf="escontratista">
        <mat-form-field appearance="outline" hideRequiredMarker>
          <mat-label>
            Seleccione
          </mat-label>
          <mat-select matSelect [(ngModel)]="model.codigoSolicitante" name="codigoSolicitante" [disabled]="!escontratista">
            <mat-option *ngFor="let item of listaSolicitantes; index as i;" [value]='item.codigoUsuario'>{{ item.nombres + ' ' + item.apellidos}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
  <!-- <pre>{{model| json}}</pre> -->